<template>
  <dialog-drag
    :style="`width: ${youtubeVideoWidth}px; height: ${youtubeVideoHeight}px; position: fixed; z-index: 9999;`"
    class="youtube-dialog"
    :options="initialPosition"
    @close="$emit('close')"
  >
    <div
      ref="yvpWrapper"
      class="yvp-wrapper"
    >
      <div class="yvp-header">
        <div class="yvp-title">
          <feather-icon
            icon="PlayCircleIcon"
            size="15"
            class="yvp-play-icon"
          />
          <span>Video</span>
        </div>
        <div class="yvp-controls">
          <button
            class="yvp-btn"
            :title="youtubeMaximized ? 'Restore' : 'Expand'"
            @click="maximizeMinimizeYoutube"
          >
            <feather-icon
              size="14"
              :icon="youtubeMaximized ? 'MinimizeIcon' : 'MaximizeIcon'"
            />
          </button>
          <button
            class="yvp-btn"
            title="Fullscreen"
            @click="toggleFullscreen"
          >
            <feather-icon
              size="14"
              :icon="isFullscreen ? 'Minimize2Icon' : 'Maximize2Icon'"
            />
          </button>
          <button
            class="yvp-btn yvp-btn-close"
            title="Close"
            @click="$emit('close')"
          >
            <feather-icon
              size="14"
              icon="XIcon"
            />
          </button>
        </div>
      </div>
      <div class="yvp-body">
        <iframe
          :width="youtubeVideoWidth"
          :height="youtubeVideoHeight - 44"
          :src="youtubeVideoLink"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        />
      </div>
    </div>
  </dialog-drag>
</template>

<script>
import DialogDrag from 'vue-dialog-drag'

export default {
  components: { DialogDrag },
  props: {
    youtubeVideoLink: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      youtubeMaximized: false,
      isFullscreen: false,
      youtubeVideoHeight: 315,
      youtubeVideoWidth: 560,
    }
  },
  computed: {
    initialPosition() {
      return {
        top: Math.max(20, Math.round((window.innerHeight - 315) / 2)),
        left: Math.max(20, Math.round((window.innerWidth - 560) / 2)),
      }
    },
  },
  mounted() {
    document.addEventListener('fullscreenchange', this.onFullscreenChange)
  },
  beforeDestroy() {
    document.removeEventListener('fullscreenchange', this.onFullscreenChange)
  },
  methods: {
    maximizeMinimizeYoutube() {
      if (this.youtubeMaximized) {
        this.youtubeVideoWidth = 560
        this.youtubeVideoHeight = 315
        this.youtubeMaximized = false
      } else {
        this.youtubeVideoWidth = window.innerWidth
        this.youtubeVideoHeight = window.innerHeight
        this.youtubeMaximized = true
      }
    },
    async toggleFullscreen() {
      try {
        if (!document.fullscreenElement) {
          await this.$refs.yvpWrapper.requestFullscreen()
        } else {
          await document.exitFullscreen()
        }
      } catch {
        this.maximizeMinimizeYoutube()
      }
    },
    onFullscreenChange() {
      this.isFullscreen = !!document.fullscreenElement
    },
  },
}
</script>

<style src='vue-dialog-drag/dist/vue-dialog-drag.css'></style>
<style lang="scss">
.youtube-dialog {
  border: none !important;
  background: transparent !important;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.5) !important;
  border-radius: 10px !important;
  overflow: visible !important;

  .dialog-header {
    display: none !important;
  }
}

.yvp-wrapper {
  border-radius: 10px;
  overflow: hidden;
  background: #000;

  &:fullscreen,
  &:-webkit-full-screen {
    border-radius: 0;

    .yvp-body iframe {
      width: 100vw !important;
      height: calc(100vh - 44px) !important;
    }
  }
}

.yvp-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  cursor: move;
  user-select: none;
}

.yvp-title {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.yvp-play-icon {
  color: #ff4444 !important;
}

.yvp-controls {
  display: flex;
  align-items: center;
  gap: 4px;
}

.yvp-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border: none;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.15s ease;
  padding: 0;

  &:hover {
    background: rgba(255, 255, 255, 0.22);
  }

  &.yvp-btn-close:hover {
    background: #e53935;
  }

  svg {
    display: block;
  }
}

.yvp-body {
  display: block;
  line-height: 0;

  iframe {
    display: block;
  }
}
</style>
